import { AfterViewInit, Component, OnDestroy, OnInit, ViewChild, ElementRef } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { Subject, Subscription } from 'rxjs';
import { ApiServiceProject } from '../../../apis/ApiServiceProject';
import { Router, ActivatedRoute } from '@angular/router';
import { ListAssigned, ProjectDetailsDto, ListWeek, ListProgress, ListStages, ListRisksMatrix, ListMilestones, ViewRisk, ListDependence } from '../../../interfaces/project/list/projectDetailsDto';
import { DataTableDirective } from 'angular-datatables';
import { GetPermisses, TableOneSearch } from 'src/app/web/util/formatDataTable';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import { ErrorService } from 'src/app/shared/services/errors.service';


@Component({
  selector: 'app-project-details',
  templateUrl: './project-details.component.html',
  styleUrls: ['./project-details.component.scss']
})
export class ProjectDetailsComponent implements OnInit, AfterViewInit, OnDestroy {


  @ViewChild(DataTableDirective, { static: false })
  dtElement: DataTableDirective;
  dtTrigger = new Subject();
  dtOptions = TableOneSearch();
  idleader:number;
  id: any;
  fechaTermino: string;
  projectDetailsDto: ProjectDetailsDto[] = [];
  developersTeam: ListAssigned[] = [];
  listLastWeek: ListWeek[] = [];
  listCurrentWeek: ListWeek[] = [];
  listProgress: ListProgress[] = [];
  listStages: ListStages[] = [];
  listRisksMatrix: ListRisksMatrix[] = [];
  listMilestones: ListMilestones[] = [];
  idSubscription: Subscription;
  viewRisk: ViewRisk[] = [];
  permisoOptionAdminTeam = true;
  
  constructor(
    private apiService: ApiServiceProject,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private spinner: NgxSpinnerService,
    private errorService:ErrorService

  ) {
    this.idSubscription = this.activatedRoute.params.subscribe(params => {
      return this.id = params['id'];
    })
  }

  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
    this.idSubscription.unsubscribe();
  }

  ngOnInit(): void {
  
    this.spinner.show()
    this.permisoOptionAdminTeam = GetPermisses(5);
    this.dtOptions = TableOneSearch()
    // this.apiService.getService(`list-project-assigned-project?id_project=${this.id}`).subscribe({
    //   next: (data) => {
        
    //     if (data) {
    //       this.developersTeam = data['listAssigned'];
          
          
    //     } else {
    //       this.spinner.hide()
    //       Swal.fire({title:data.error,text: '',icon: 'error',heightAuto: false});
    //     }
    //   },
    //   error: (error) => {
    //     this.errorService.error(error);
    //   }
    // })

    this.apiService.getService(`project-view?id_project=${this.id}`).subscribe({
      next: (data) => {
        
        if (data) {
          this.projectDetailsDto = data;
          this.developersTeam = data['listAssigned'];
          this.listLastWeek = data['listLastWeek'];
          this.listCurrentWeek = data['listCurrentWeek'];
          this.listProgress = data['listProgress'];
          this.listStages = data['listStages'];
          this.listRisksMatrix = data['listRisksMatrix'];
          this.listMilestones = data['listMilestones'];
          this.idleader=data['idUser']
          this.rerender();
          this.spinner.hide()
          
        } else {
          this.spinner.hide()
          Swal.fire({title:data.error,text: '',icon: 'error',heightAuto: false});
        }
      },
      error: (error) => {
        this.errorService.error(error);
      }
    })

    
   
  }
  
  riskCreate(id) {

    localStorage.setItem("title", this.projectDetailsDto['projectName']);
    
    this.router.navigate([`/pdg/project/${id}/risk/create`]);
  }

  riskEdit(id: any, item:any) {

    localStorage.setItem("title", this.projectDetailsDto['projectName']);
    localStorage.setItem("info-mtn", JSON.stringify(item));
    
    this.router.navigate([`/pdg/project/${id}/risk/update`]);
  }
  projectStage() {

    localStorage.setItem("title", this.projectDetailsDto['projectName']);
    
    this.router.navigate([`/pdg/project/${this.id}/stages`]);
  }
  ngAfterViewInit(): void {
    this.dtTrigger.next();
  }

  rerender(): void {
    this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
      dtInstance.destroy();
      this.dtTrigger.next();
    });
  }

  isValid(field: any) {
    if (field === null || field === undefined || field === '' || field === 0 || field === '0') {
      return true;
    }
  }
  weeklyEdit(item:any, id: any){

    localStorage.setItem("title", this.projectDetailsDto['projectName']);
    localStorage.setItem("info-mtn", JSON.stringify(item));
    this.router.navigateByUrl('/pdg/project/'+id+'/weekly/edit');
  }

  milestoneEdit(id: any ,item:any){
    localStorage.setItem("title", this.projectDetailsDto['projectName']);
    localStorage.setItem("info-mtn", JSON.stringify(item));
    this.router.navigateByUrl('/pdg/project/milestone/update/'+id+'');
  }

  weeklyCreat(id: any){

    localStorage.setItem("title", this.projectDetailsDto['projectName']);
    this.router.navigateByUrl('/pdg/project/'+id+'/weekly/create');
  }

   weeklyDelete(id:any){
      Swal.fire({
                title: 'Eliminar',
                text: '¿Desea eliminar registro?',
                icon: 'warning',
                showCancelButton:true,
                confirmButtonText: 'Aceptar',
                cancelButtonText:"No, cancelar",
                heightAuto: false
              }).then((res) => {
                if (res.isConfirmed) {
                  this.spinner.show()
                  this.apiService.deleteService('project-view-progress-delete?id=' + id).subscribe({
                    next: (rs: any) => {
                      if (rs) {
                        this.spinner.hide();
                        Swal.fire({title:'Exito!',text: 'Se ha eliminado con exito!',icon: 'success',heightAuto: false}).then(()=>{location.reload()})
                        
                      } else {
                          this.spinner.hide();
                          Swal.fire({
                          title:  rs.error,
                          text: '',
                          icon: 'error',
                          heightAuto: false
                          }); } },
                    error: (error) => {
                      this.errorService.error(error);
                    },});
                }
                else if ( res.dismiss === Swal.DismissReason.cancel){
                  Swal.fire({
                    title: 'Cancelado',
                    text: 'Operación cancelada.',
                    icon: 'error',
                    heightAuto: false
                    })

                }
              });
    
    
  }
  crearHito() {
  this.spinner.show();
  this.router.navigate([`/pdg/project/milestone/create/${this.id}`]);
  }

  crearEquipo() {
    //'project/create/:id/:step
    this.router.navigate([`/pdg/project/edit/${this.id}/3`]);
    }

  stageDeleteMilestone(id:any){
    Swal.fire({
              title: 'Eliminar',
              text: '¿Desea eliminar el hito?',
              icon: 'warning',
              showCancelButton:true,
              confirmButtonText: 'Aceptar',
              cancelButtonText:"No, cancelar",
              heightAuto: false
            }).then((res) => {
              if (res.isConfirmed) {
                this.spinner.show()
                this.apiService.deleteService('project-view-milestone-delete?id=' + id).subscribe({
                  next: (rs: any) => {
                    if (rs) {
                      this.spinner.hide();
                      Swal.fire({title:'Exito!',text: 'Se ha eliminado con exito!',icon: 'success',heightAuto: false}).then(()=>{location.reload()})
                      
                    } else {
                        this.spinner.hide();
                        Swal.fire({
                        title:  rs.error,
                        text: '',
                        icon: 'error',
                        heightAuto: false
                        }); } },
                  error: (error) => {
                    this.errorService.error(error);
                  },});
              }
              else if ( res.dismiss === Swal.DismissReason.cancel){
                Swal.fire({
                  title: 'Cancelado',
                  text: 'Operación cancelada.',
                  icon: 'error',
                  heightAuto: false
                  })

              }
            });
  
  
}

  stageDeleteEquipment(id:any,name:string){
    Swal.fire({
              title: 'Eliminar',
              text: '¿Desea eliminar el Usuario '+ this.transformName(name) +'?',
              icon: 'warning',
              showCancelButton:true,
              confirmButtonText: 'Aceptar',
              cancelButtonText:"No, cancelar",
              heightAuto: false
            }).then((res) => {
              if (res.isConfirmed) {
                this.spinner.show()
                this.apiService.deleteService('project-delete-assigned-project?id=' + id).subscribe({
                  next: (rs: any) => {
                    if (rs) {
                      this.spinner.hide();
                      Swal.fire({title:'Exito!',text: 'Se ha eliminado con exito!',icon: 'success',heightAuto: false}).then(()=>{location.reload()})
                      
                    } else {
                        this.spinner.hide();
                        Swal.fire({
                        title:  rs.error,
                        text: '',
                        icon: 'error',
                        heightAuto: false
                        }); } },
                  error: (error) => {
                    this.errorService.error(error);
                  },});
              }
              else if ( res.dismiss === Swal.DismissReason.cancel){
                Swal.fire({
                  title: 'Cancelado',
                  text: 'Operación cancelada.',
                  icon: 'error',
                  heightAuto: false
                  })

              }
            });


  }

  stageActiveEquipment(id:any,name: string){
    Swal.fire({
              title: 'Activar',
              text: '¿Está seguro de activar al usuario '+ this.transformName(name) +' del proyecto?',
              icon: 'warning',
              showCancelButton:true,
              confirmButtonText: 'Confirmar',
              heightAuto: false
            }).then((res) => {
              if (res.isConfirmed) {
                this.spinner.show()
                this.apiService.putService('project-active-assigned-project?id=' + id).subscribe({
                  next: (rs: any) => {
                    if (rs) {
                      this.spinner.hide();
                      Swal.fire({title:'Exito!',text:'Se ha activado con exito!',icon: 'success',heightAuto: false}).then(()=>{location.reload()})
                      
                    } else {
                        this.spinner.hide();
                        Swal.fire({
                        title:  rs.error,
                        text: '',
                        icon: 'error',
                        heightAuto: false
                        }); } },
                  error: (error) => {
                    this.errorService.error(error);
                  },});
              }
              else if ( res.dismiss === Swal.DismissReason.cancel){
                Swal.fire({
                  title: 'Cancelado',
                  text: 'Operación cancelada.',
                  icon: 'error',
                  heightAuto: false
                  })

              }
            });


  }

  stageEndAssignment(id:any,name:string){
    Swal.fire({
              title: '¿Desea terminar la Asignación?',
              text: 'Si esta seguro de esta acción, seleccione una fecha de termino y presione confirmar.',
              html: "<input type='date' id='fechaTermino' name='fechaTermino' #fechaTermino class='custom-outline-input date mt-3'>",
              icon: 'warning',
              showCancelButton:true,
              confirmButtonText: 'Confirmar',
              cancelButtonText:"No, cancelar",
              heightAuto: false
             
            }).then((res) => {
              
              Swal.getInput()
              // if (res.isConfirmed) {
              //   this.spinner.show()
              //   this.apiService.deleteService('project-delete-assigned-project?id=' + id).subscribe({
              //     next: (rs: any) => {
              //       if (rs) {
              //         this.spinner.hide();
              //         Swal.fire('Bien!','Se ha eliminado con exito!','success').then(()=>{location.reload()})
                      
              //       } else {
              //           this.spinner.hide();
              //           Swal.fire({
                    // title:  rs.error,
                    // text: '',
                    // icon: 'error',
                    // heightAuto: false
                    // }); } },
              //     error: (error) => {
              //       this.spinner.hide();
              //       Swal.fire({title:  error.error.message +'',text: '',icon: 'error',heightAuto: false});
              //     },});
              // }
              // else if ( res.dismiss === Swal.DismissReason.cancel){
              //   Swal.fire(
              //     'Cancelado',
              //     'Operación cancelada.',
              //     'error'
              //   )

              // }
            });


  }

  clickme(username:string) {
  }

  transformName(name: string): string {
    if(name == null){
      return "Sin Colaborador";
    }
    let names = name.split('.');
    let nameString = "";
    for (let name of names) {
      nameString += name.charAt(0).toUpperCase() + name.slice(1) + " ";
    }
    return nameString;
  }

  riskDelete(id:any){
    Swal.fire({
      title: 'Eliminar',
      text: '¿Desea eliminar riesgo?',
      icon: 'warning',
      showCancelButton:true,
      confirmButtonText: 'Aceptar',
      cancelButtonText:"No, cancelar",
      heightAuto: false
    }).then((res) => {
      if (res.isConfirmed) {
        this.spinner.show()
        this.apiService.deleteService('project-view-risks-delete?id=' + id).subscribe({
          next: (rs: any) => {
            if (rs) {
              this.spinner.hide();
              Swal.fire({title:'Exito!',text: 'Se ha eliminado con exito!',icon: 'success',heightAuto: false}).then(()=>{location.reload()})
              
            } else {
                this.spinner.hide();
                Swal.fire({
                title:  rs.error,
                text: '',
                icon: 'error',
                heightAuto: false
                }); } },
          error: (error) => {
            this.errorService.error(error);
          },});
      }
      else if ( res.dismiss === Swal.DismissReason.cancel){
        Swal.fire({
          title: 'Cancelado',
          text: 'Operación cancelada.',
          icon: 'error',
          heightAuto: false
          })

      }
    });
  }
  riskStatus(id:any, set){
       
    let estado = '';
    if (set == 1) {
      estado = '¿Desea activar el estado?';
    }else if (set ==2) {
      estado = '¿Desea desactivar el estado?';
    }else{
      estado = '¿Desea colocar el estado en issue?';
    }

        Swal.fire({
          title: 'Cambiar',
          text: estado,
          icon: 'question',
          showCancelButton:true,
          confirmButtonText:'Aceptar',
          cancelButtonColor:"No, cancelar",
          heightAuto: false
        }).then((res) =>{
          if (res.isConfirmed) {
            this.spinner.show()
            this.apiService.putService('project-view-risks-changes-status?id='+id +'&status=' +set).subscribe({
              next: (rs: any) =>{
                if (rs) {
                  this.spinner.hide();
                  Swal.fire({title:'Exito!',text:'Se actualizado el estado correctamente',icon: 'success',heightAuto: false}).then(()=>{location.reload()})
                }else{
                  this.spinner.hide();
                  Swal.fire({title:rs.error ,text: '',icon: 'error',heightAuto: false});
                }
              },error: (error) =>{
                this.errorService.error(error);
              }});
    
        }else if ( res.dismiss === Swal.DismissReason.cancel){
          Swal.fire({
            title: 'Cancelado',
            text: 'Operación cancelada.',
            icon: 'error',
            heightAuto: false
            })
          }
      });
  
       


  }
}